import React, { useEffect, useState } from 'react';
import backgroundImage from '../../assets/PathianCurves.png';
import { useNavigate, useLocation } from 'react-router';
import { Button, Message, Dimmer, Loader } from 'semantic-ui-react';
import { useUsers } from '../../providers/UsersProvider';

const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '87vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
};

const signInStyle = {
    fontSize: '25px',
    color: '#00A7B5',
    margin: '10px',
    display: 'flex',
    justifyContent: 'flex-start',
    wordSpacing: '-0.2em',
};

const welcomeStyle = {
    fontSize: '40px',
    color: '#00A7B5',
    margin: '10px',
    display: 'flex',
    justifyContent: 'flex-start',
    wordSpacing: '-0.2em',
};

const buttonRow = {
    display: 'flex',
    justifyContent: 'space-between'
};

export const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [resetToken, setResetToken] = useState();
    const [userId, setUserId] = useState();
    const [isInvite, setIsInvite] = useState(false);
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { search } = useLocation();
    const { forgotPassword, forgotPasswordChange } = useUsers();

    useEffect(() => {
        const params = new URLSearchParams(search);
        const token = params.get('resetToken');
        const id = params.get('userId');
        if (token && id) {
            setResetToken(token);
            setUserId(id);
        }
        setIsInvite(params.get('invite') === 'true');
    }, [search]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSuccess(false);
        setLoading(true);

        if (resetToken && userId) {
            try {
                if (password !== passwordConfirm) {
                    setErrors(["Password and Password Confirmation do not match"]);
                    setLoading(false);
                    return;
                }

                await forgotPasswordChange(resetToken, userId, password, passwordConfirm);
                setErrors([]);
                setSuccess(true);
            } catch (err) {
                setErrors(err?.response?.data?.errors.map(error => {
                    return error;
                }));
            }
        } else {
            await forgotPassword(email);
            setErrors([]);
            setSuccess(true);
        }

        setLoading(false);
    };

    return (
        <>
            <Dimmer active={loading}>
                <Loader size='massive' active={loading}></Loader>
            </Dimmer>
            <div
                style={containerStyle}
                className="Franklin-font"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '0 0 13%'
                    }}
                >
                    <p style={welcomeStyle}>{isInvite ? "Account Setup" : (resetToken && userId) ? "Password Reset" : "Forgot Password"}</p>
                    <p style={signInStyle}>{(resetToken && userId) ? "Please enter a new password." : "Please enter your username."}</p>
                </div>
                <div>
                    <form onSubmit={handleSubmit}>
                        <div>
                            {
                                !(resetToken && userId) ? (
                                    <>
                                        <label
                                            style={{
                                                fontSize: '20px',
                                                color: '#254A5D',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                            }}
                                        >
                                            Username
                                        </label>
                                        <input
                                            type="text"
                                            name="Username"
                                            id="Username"
                                            placeholder="Username"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            required
                                        ></input>
                                        <br />
                                    </>
                                ) : null
                            }
                            {
                                (resetToken && userId) ? (
                                    <>
                                        <label
                                            style={{
                                                fontSize: '20px',
                                                color: '#254A5D',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                            }}
                                        >
                                            Password
                                        </label>
                                        <input
                                            type="Password"
                                            name="Pass"
                                            id="Pass"
                                            placeholder="Password"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            autoComplete="new-password"
                                            required
                                        ></input>
                                        <br />

                                        <label
                                            style={{
                                                fontSize: '20px',
                                                color: '#254A5D',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                            }}
                                        >
                                            Password Confirmation
                                        </label>
                                        <input
                                            type="Password"
                                            name="PassConfirm"
                                            id="PassConfirm"
                                            placeholder="Password Confirmation"
                                            value={passwordConfirm}
                                            onChange={e => setPasswordConfirm(e.target.value)}
                                            autoComplete="new-password"
                                            required
                                        ></input>
                                        <br />
                                    </>
                                ) : null
                            }

                            <div style={buttonRow}>
                                <button type="submit" name="logIn" id="logIn" value="Login" disabled={success}>
                                    Submit
                                </button>
                                <Button
                                    type="button"
                                    name="cancel"
                                    id="cancel"
                                    size={'large'}
                                    style={{ boxShadow: '1px 1px 3px grey', margin: '15px 0px 15px 0px' }}
                                    onClick={() => navigate('/login')}
                                >
                                    {success ? 'Log In' : 'Cancel'}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
                {errors.length > 0 ? (
                    <div>
                        <Message color="red" list={errors} />
                    </div>
                ) : null}
                {success ? (
                    <Message color="green" content={isInvite ? "Account set up successfully, please proceed to log in." : (resetToken && userId) ? "Password changed, please proceed to log in." : "Password reset link was sent, please check your email."} />
                ) : null}
            </div>
        </>
    );
};
